import { FunctionComponent, useEffect, useState } from 'react';
import { IBarChart, IBarChartData } from '../Models/BarChartModel';
import './HorizontalBarChart.scss';
const COLORS = ['#FFD000', '#1A1446', '#28A3AF', '#99E5EA', '#1A1446', '#565656'];

const HorizontalBarChart: FunctionComponent<any> = (props: IBarChart) => {
  const [barChartData, setBarChartData] = useState<IBarChartData[]>([]);
  const [max_val, setMaxVal] = useState(0);

  useEffect(() => {
    if (props.barChartInput && props.barChartInput.length > 0) {
      const vals = props.barChartInput.map((d) => {
        return d.value;
      });
      setMaxVal(Math.max(...vals));
      setBarChartData(props.barChartInput);
    }
  }, [props.barChartInput]);

  const getWidth = (value: number) => {
    const min_val = 3;
    let width = value > 0 ? (value / max_val) * 100 : 0;
    return width < min_val && width > 0 ? min_val : width;
  };

  const getBackgroundColor = (index: number) => {
    return COLORS[index % COLORS.length];
  };

  return (
    <div className="horizontal-bar-chart">
      {props.chartTitle && <div className="chart-title">{props.chartTitle}</div>}
      {barChartData && barChartData.length > 0 && (
        <div className="bar-chart-section">
          {barChartData.map((data, index) => (
            <div className="bar-section">
              <div className="bar-label">{data.name}</div>
              <div className="bar-container">
                <div className="bar-background">
                  <div
                    key={index}
                    className="bar"
                    style={{ width: `${getWidth(data.value)}%`, backgroundColor: getBackgroundColor(index) }}
                  ></div>
                </div>
                <div className="bar-value">{data.value}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HorizontalBarChart;
